import type { FC } from "react"
import { Trans } from "react-i18next"
import Content from "components/Content"
import { useDashboard } from "./hooks"
import { LeftSidebar, RightSidebar, PostsFeed } from "./components"

const Dashboard: FC = () => {
  const { data, isLoading, isError, error } = useDashboard()

  if (isLoading) {
    return (
      <Content title={<Trans i18nKey="dashboard.title" />}>
        <div className="flex gap-4">
          <div className="w-full lg:w-[27%] space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white shadow rounded-lg h-48 animate-pulse" />
            ))}
          </div>
          <div className="w-full lg:w-[46%] space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white shadow rounded-lg h-32 animate-pulse" />
            ))}
          </div>
          <div className="w-full lg:w-[27%] space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white shadow rounded-lg h-48 animate-pulse" />
            ))}
          </div>
        </div>
      </Content>
    )
  }

  if (isError) {
    return (
      <Content title={<Trans i18nKey="dashboard.title" />}>
        <div className="text-center py-12 text-red-500">
          <Trans i18nKey="dashboard.error.title" />
          <p className="mt-2 text-sm">{error?.message}</p>
        </div>
      </Content>
    )
  }

  if (!data) {
    return (
      <Content title={<Trans i18nKey="dashboard.title" />}>
        <div className="text-center py-12 text-gray-500">
          <Trans i18nKey="dashboard.error.noData" />
        </div>
      </Content>
    )
  }

  return (
    <Content title={<Trans i18nKey="dashboard.title" />}>
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="w-full lg:w-[27%]">
          <LeftSidebar
            user={data.user}
            eventos={data.eventos}
            visits={data.nextVisits}
            integrations={data.integrations}
            extraCards={data.extraCards}
          />
        </div>

        <div className="w-full lg:w-[46%]">
          <PostsFeed />
        </div>

        <div className="w-full lg:w-[27%]">
          <RightSidebar
            suppliers={data.suppliers}
            highlights={data.highlights}
            commercials={data.commercials}
            documents={data.documents}
          />
        </div>
      </div>
    </Content>
  )
}

export default Dashboard